import React from 'react';
import { AwardIcon, ShieldCheckIcon, ActivityIcon } from 'lucide-react';
export function DoctorSection() {
  return <section className="w-full bg-gray-50 py-20 px-4" data-id="element-52">
      <div className="max-w-6xl mx-auto" data-id="element-53">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-54">
          <h2 className="text-4xl md:text-5xl font-extrabold text-brand-black mb-4" data-id="element-55">
            Doctor Recommended Low-Level Light Therapy
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-56">
            Trusted by medical professionals as a safe, effective alternative to
            drugs and surgery
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-57">
          {/* Doctor Image Placeholder */}
          <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-58">
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/dERnZyi8ZG3mWYLeMB59Y6/Untitled-design-5-1.png" alt="Medical professional recommending CrownControl red light therapy" className="w-full h-auto" data-id="element-60" />
            </div>
            <div className="text-center" data-id="element-61">
              <p className="text-xl font-bold text-brand-black mb-2" data-id="element-62">
                Dr. Sarah Mitchell
              </p>
              <p className="text-gray-600" data-id="element-63">Board-Certified Dermatologist</p>
            </div>
          </div>

          {/* Credibility Content */}
          <div data-id="element-64">
            <div className="bg-white rounded-xl shadow-lg p-8 mb-6" data-id="element-65">
              <blockquote className="text-lg text-gray-700 leading-relaxed italic mb-4" data-id="element-66">
                "Red light therapy has emerged as one of the most promising
                non-invasive treatments for hair loss. The 650nm wavelength
                stimulates cellular activity in hair follicles, promoting
                natural regrowth without the side effects associated with
                pharmaceutical interventions."
              </blockquote>
            </div>

            {/* Credibility Icons */}
            <div className="space-y-6" data-id="element-67">
              <div className="flex items-start gap-4" data-id="element-68">
                <div className="bg-brand-red rounded-lg p-3 flex-shrink-0" data-id="element-69">
                  <AwardIcon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-70" />
                </div>
                <div data-id="element-71">
                  <h3 className="text-xl font-bold text-brand-black mb-2" data-id="element-72">
                    Clinically Studied
                  </h3>
                  <p className="text-gray-700" data-id="element-73">
                    Backed by over 50 peer-reviewed studies demonstrating
                    efficacy in hair regrowth
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-74">
                <div className="bg-brand-red rounded-lg p-3 flex-shrink-0" data-id="element-75">
                  <ShieldCheckIcon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <h3 className="text-xl font-bold text-brand-black mb-2" data-id="element-78">
                    FDA Cleared Technology
                  </h3>
                  <p className="text-gray-700" data-id="element-79">
                    Our 650nm red light wavelength is FDA-cleared for promoting
                    hair growth
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-80">
                <div className="bg-brand-red rounded-lg p-3 flex-shrink-0" data-id="element-81">
                  <ActivityIcon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <h3 className="text-xl font-bold text-brand-black mb-2" data-id="element-84">
                    Non-Invasive
                  </h3>
                  <p className="text-gray-700" data-id="element-85">
                    No surgery, no needles, no hormones—just safe, natural light
                    therapy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}